import type { IChipModel } from '@/interfaces/models';
import { ActionType, type Action } from '@/models/HistoryModel';
import type { InterfaceLinkInstanceId } from '@/types/ids';

/** Renaming remains reversible even when two authored pins share a label. */
export function createAdapterLabelAction(
  chip: IChipModel,
  linkId: InterfaceLinkInstanceId,
  newLabel: string,
): Action {
  const oldLabel = chip.interfaceLinkMap.get(linkId)?.label ?? '';
  const before = { ...chip.adapterSignals };
  let after: Record<string, string> | undefined;
  return {
    type: ActionType.EditLabels,
    description: `Set signal label ${newLabel}`,
    do() {
      chip.renameInterfaceLink(linkId, newLabel);
      if (after) {
        chip.adapterSignals = { ...after };
        chip.rebuildTemplateGraph();
      } else after = { ...chip.adapterSignals };
    },
    undo() {
      chip.renameInterfaceLink(linkId, oldLabel);
      chip.adapterSignals = { ...before };
      chip.rebuildTemplateGraph();
    },
  };
}
